import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Branch, getBranchesForCoursePayload } from './types'
import { WebexUser } from '../coachingCenter/types'

export const getBranchesForCourse = createAsyncThunk(
  'branch/getBranchesForCourse',
  async ({
    coachingCentreId,
    courseId
  }: getBranchesForCoursePayload): Promise<Array<Branch>> => {
    const response = await api.get(
      `${apiEndpoints.getBranchesForCourse}?coachingCentreId=${coachingCentreId}&courseId=${courseId}`
    )
    return response?.data
  }
)

export const getBranchesByInstitute = createAsyncThunk(
  'batch/getBranchesByInstitute',
  async (coachingCentreId: string): Promise<Array<Branch>> => {
    const response = await api.get(
      `${apiEndpoints.getBranchByInstitute}?coachingCentreId=${coachingCentreId}`
    )
    return response?.data
  }
)

export const getWebexUserByBranch = createAsyncThunk(
  'session/getWebexUserByBranch',
  async (branchId: string): Promise<WebexUser> => {
    const { data } = await api.get(
      `${apiEndpoints.getWebexUserByBranch}?branchIds=${branchId}`
    )
    return data.data
  }
)
